<template>
	<div style="margin-left:7px;" v-if="roleRules.GRAD_PROG_FLG === 'Y'">
		<template v-if="roleRules.GRAD_REQ_CATEGORIES === 'Y'">
			<div class="instructions alert alert-info" v-if="!!graduationRequirements.HEADER_TEXT && graduationRequirements.HEADER_TEXT.length > 0" v-html="graduationRequirements.HEADER_TEXT" />
			<div v-for="req in graduationRequirementsKeys" :key="req">
				<template v-if="!!graduationRequirements.categories[req].ITEMS && graduationRequirements.categories[req].ITEMS.length">
					<h1 class="gray-header">
						{{ graduationRequirements.categories[req].CATEGORY_DESC }}
					</h1>
					<h2 v-if="graduationRequirements.categories[req].COMPLETED_FLG === 'Y'" style="margin-left:15px;text-transform: none;">
						{{ $t('MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirementsMet', { student: selectedStudent.FIRST_NAME, requirement: graduationRequirements.categories[req].CATEGORY_DESC } ) }}
					</h2>
					<h2 v-else style="margin-left:15px;text-transform: none;">
						{{ $t('MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirementsNotMet', { student: selectedStudent.FIRST_NAME, requirement: graduationRequirements.categories[req].CATEGORY_DESC } ) }}
					</h2>
					<div class="table-responsive" v-if="roleRules.GRAD_REQ_ITEMS === 'Y' && !!graduationRequirements.categories[req].ITEMS && graduationRequirements.categories[req].ITEMS.length">
						<table tabindex="0" class="table table-striped table-bordered default-table">
							<thead>
								<tr>
									<th width="auto" tabindex="0" scope="col" class="">
										Requirement
									</th>
									<th width="auto" tabindex="0" scope="col" class="">
										Status
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, itemIdx) in graduationRequirements.categories[req].ITEMS" :key="`item-${item.CATEGORY_CODE}-${item.ITEM_CODE}_${itemIdx}`"> 
									<td tabindex="0">
										<span>
											{{item.ITEM_DESC}}
										</span>
										<ul v-if="roleRules.GRAD_REQ_SUBITEMS === 'Y' && !!item.SUBITEMS && item.SUBITEMS.length > 0">
											<li v-for="(subitem, subitemIdx) in item.SUBITEMS" :key="`item-${item.CATEGORY_CODE}-${item.ITEM_CODE}_${itemIdx}_${subitem.SUBITEM_CODE}_${subitemIdx}`">
												<span v-if="subitem.MULTIPLE_ALLOWED_FLG == 'Y'">({{subitem.COUNT_INT}}) </span>{{subitem.SUBITEM_DESC}}
											</li>
										</ul>
									</td>
									<td tabindex="0">
										<span data-v-531c1c6d="">
											{{item.STATUS_DESC}}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</template>
			</div>
		</template>
		<h1 class="gray-header" v-if="dataExists && roleRules.GRAD_COURSE_WORK === 'Y'">
			{{ $t('MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirements') }}
		</h1>
		<transition name="fade" v-if="dataExists && roleRules.GRAD_COURSE_WORK === 'Y'">
			<div>
				<div v-for="(department, index) in byDepartmentData" :key="index">
					<panel-basic :title="department.GRAD_RULE_NAME"
											 :id="`department_${index}`"
											 :collapsable="true"
											 :headingLevel="3">
						<template slot="title">
							{{ department.GRAD_RULE_NAME }}
						</template>
						<p>
							<strong>
								{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsRequiredWithColon') }}
							</strong>
							<span class="text-lg">
								{{ department.TOTAL_CREDITS.toPrecision(4) }}
							</span>
						</p>
						<div class="row">
							<div class="col-sm-3">
								<progress-bar :id="`progress_bar_department_${index}`"
															:percent="getPercent(department)"
															size="sm">
								</progress-bar>
							</div>
							<div class="col-sm-9">
								<p class="text-right" v-if="department.RULE_SATISFIED === 'Y'">
									<template v-if="department.CREDITS_EARNED < department.TOTAL_CREDITS">
										{{ $t('MAIN_CONTENT.GraduationProgressReport.departmentRequirementsSatisfiedUponCompletion') }}
									</template>
									<template v-else>
										{{ $t('MAIN_CONTENT.GraduationProgressReport.requirementHasBeenSatisfiedWithPeriod') }}
									</template>
								</p>
							</div>
						</div>
						<progress-report-departments :departmentColumnsConfig="graduationProgressByDepartment"
																				:tableData="department">
						</progress-report-departments>
						<br />
						<!-- Department summary details start -->
						<div class="row panel-summary-group">
							<div class="panel-summary panel-summary-success col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsEarned') }}</h4>
									<p class="text-center">
										<strong class="total">
											{{ department.CREDITS_EARNED | fixed(3) }}
										</strong> <span class="unit">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}</span>
									</p>
								</div>
							</div>

							<div class="panel-summary panel-summary-info col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsInProgress') }}</h4>
									<p class="text-center">
										<strong class="total">
											{{ department.CREDITS_IN_PROGRESS | fixed(3) }}
										</strong> <span class="unit">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}</span>
									</p>
								</div>
							</div>

							<div class="panel-summary panel-summary-warning col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">
										{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsStillNeededFirstLettersCapatilized') }}
									</h4>
									<p class="text-center">
										<strong class="total">
											<template v-if="(+department.CREDITS_IN_PROGRESS + +department.CREDITS_EARNED) <= +department.TOTAL_CREDITS">
												{{ ((department.TOTAL_CREDITS - department.CREDITS_EARNED) - department.CREDITS_IN_PROGRESS) | fixed(3) }}
											</template>
											<template v-else>
												{{ 0 | fixed(3) }}
											</template>
										</strong> <span class="unit">
											{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}
										</span>
									</p>
								</div>
							</div>
						</div>
						<!-- Department summary details end -->
					</panel-basic>
				</div>
				<!-- Years totals summary data -->
				<template>
					<panel-basic :title="$t( 'MAIN_CONTENT.GraduationProgressReport.summary' )"
											 id="yearly-summary"
											 :collapsable="true"
											 :headingLevel="3">
						<template slot="title">
							{{ $t('MAIN_CONTENT.GraduationProgressReport.summary') }}
						</template>
						<strong>
							<div class="col-xs-9">
								{{ $t('MAIN_CONTENT.GraduationProgressReport.totalCreditsRequirement') }}
							</div>
							<div class="col-xs-3" style="text-align: right;">
								{{ $t('MAIN_CONTENT.GraduationProgressReport.totalCreditsNeededWithColon', { credits: $options.filters.fixed( graduationProgressData.TRACK_INFO.TOTAL_CREDITS, 3 ) } ) }}
							</div>
						</strong>
						<progress-report-years :yearColumnsConfig="graduationProgressByYear" :tableData="totalRequirements" class="col-xs-12">
						</progress-report-years>
						<div class="panel-summary-group">
							<div class="panel-summary panel-summary-success col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsEarned') }}</h4>
									<p class="text-center">
										<strong class="total">
											{{ graduationProgressData.TRACK_INFO.CREDITS_EARNED | fixed(3) }}
										</strong> <span class="unit">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}</span>
									</p>
								</div>
							</div>

							<div class="panel-summary panel-summary-info col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsInProgress') }}</h4>
									<p class="text-center">
										<strong class="total">
											{{ graduationProgressData.TRACK_INFO.CREDITS_IN_PROGRESS | fixed(3) }}
										</strong> <span class="unit">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}</span>
									</p>
								</div>
							</div>

							<div class="panel-summary panel-summary-warning col-xs-12 col-md-4">
								<div class="panel-header">
									<h4 class="title">
										{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsStillNeededFirstLettersCapatilized') }}
									</h4>
									<p class="text-center">
										<strong class="total">
											{{ stillNeededCredits | fixed(3) }}
										</strong> <span class="unit">{{ $t('MAIN_CONTENT.GraduationProgressReport.creditsAllCaps') }}</span>
									</p>
								</div>
							</div>
						</div>
					</panel-basic>
				</template>
			</div>
		</transition>
		
		<template v-if="roleRules.GRAD_PROG_FLG !== 'Y'">
			{{ $t('MAIN_CONTENT.commonContent.invalidPermissions') }}
		</template>
	</div>
</template>

<script>
	import ProgressReportDepartments from './ProgressReportDepartments.vue';
	import ProgressReportYears from './ProgressReportYears.vue';
	import ProgressBar from '../ProgressBar.vue';

	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';

	import GraduationProgress from '../../api/GraduationProgress.js';

	import { mapGetters } from 'vuex';
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';
	export default {
		name: 'GraduationProgressReport',
		data () {
			return {
				graduationRequirements:{},
				graduationProgressData: []
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			graduationRequirementsKeys(){
				let keysArray = [];
				if(this.graduationRequirements.categories && Object.keys(this.graduationRequirements.categories)){
					keysArray = Object.keys(this.graduationRequirements.categories);
				}

				return keysArray;
			},
			stillNeededCredits() {
				let stillNeeded = this.graduationProgressData.TRACK_INFO.TOTAL_CREDITS - this.graduationProgressData.TRACK_INFO.CREDITS_EARNED - this.graduationProgressData.TRACK_INFO.CREDITS_IN_PROGRESS;
				return this.$options.filters.fixed(Math.max(stillNeeded,0), 3);
			},
			totalRequirements() {
				let list = [];
				let index = -1;

				if(!!this.graduationProgressData.TRACK_INFO) {
					if(!!this.graduationProgressData.TRACK_INFO.COURSES) {
						for(let i in this.graduationProgressData.TRACK_INFO.COURSES) {
							let progress = this.graduationProgressData.TRACK_INFO.COURSES[i];

							// Courses not in progress or is the first course in the list
							if(+i === 0 || (progress.SCHOOL_YEAR !== this.graduationProgressData.TRACK_INFO.COURSES[+i - 1].SCHOOL_YEAR && progress.CREDIT_LABEL_CODE !== 'P')) {
								list.push({SCHOOL_ID: progress.SCHOOL_ID, SCHOOL_YEAR: progress.SCHOOL_YEAR, COURSES: [], IN_PROGRESS: false});
								index++;
							} else {
								// Courses in progress
								if(progress.SCHOOL_YEAR === this.graduationProgressData.TRACK_INFO.COURSES[+i - 1].SCHOOL_YEAR && progress.CREDIT_LABEL_CODE === 'P' && this.graduationProgressData.TRACK_INFO.COURSES[+i - 1].CREDIT_LABEL_CODE !== 'P') {
									list.push({SCHOOL_ID: progress.SCHOOL_ID, SCHOOL_YEAR: progress.SCHOOL_YEAR, COURSES: [], IN_PROGRESS: true});
									index++;
								}
							}

							// Show which credits to display
							progress.DISPLAY_CREDITS = progress.CREDIT_LABEL_CODE === 'P' ?
																					this.$options.filters.fixed(progress.CREDITS_IN_PROGRESS, 3) :
																					this.$options.filters.fixed(progress.CREDITS_EARNED, 3);

							// Configure Course label
							progress.FORMATTED_COURSE_LABEL = progress.CREDIT_LABEL_CODE === 'P' ?
								`${progress.COURSE_TITLE}*` : progress.COURSE_TITLE;

							// List the final grade text based upon which values exists
							if(!!progress.FINAL_GRADE_NUMERIC && !!progress.FINAL_GRADE_ALPHA) {
								progress.FINAL_GRADE_LETTER_AND_ALPHA = `${progress.FINAL_GRADE_NUMERIC} / ${progress.FINAL_GRADE_ALPHA}`;
							} else if(!!progress.FINAL_GRADE_NUMERIC) {
								progress.FINAL_GRADE_LETTER_AND_ALPHA = progress.FINAL_GRADE_NUMERIC;
							} else if(!!progress.FINAL_GRADE_ALPHA) {
								progress.FINAL_GRADE_LETTER_AND_ALPHA = progress.FINAL_GRADE_ALPHA;
							} else {
								progress.FINAL_GRADE_LETTER_AND_ALPHA = '';
							}

							list[index].COURSES.push(progress);
						}
					}
				}

				return list;
			},
			byDepartmentData() {
				let inProgressCourses = [];
				let completedCourses = [];
				let departmentData = [];
				let index = -1;

				if(!!this.graduationProgressData.TRACK_RULES) {
					for(let d in this.graduationProgressData.TRACK_RULES) {
						let department = this.graduationProgressData.TRACK_RULES[d];
						department.COURSES_IN_PROGRESS = [];
						department.COURSES_NOT_IN_PROGRESS = [];

						for(let i in department.COURSES) {
							let course = department.COURSES[i];

							if(!!course.FINAL_GRADE_NUMERIC && !!course.FINAL_GRADE_ALPHA) {
								course.FINAL_GRADE_LETTER_AND_ALPHA = `${course.FINAL_GRADE_NUMERIC} / ${course.FINAL_GRADE_ALPHA}`;
							} else if(!!course.FINAL_GRADE_NUMERIC) {
								course.FINAL_GRADE_LETTER_AND_ALPHA = course.FINAL_GRADE_NUMERIC;
							} else if(!!course.FINAL_GRADE_ALPHA) {
								course.FINAL_GRADE_LETTER_AND_ALPHA = course.FINAL_GRADE_ALPHA;
							} else {
								course.FINAL_GRADE_LETTER_AND_ALPHA = '';
							}

							// Show which credits to display
							course.DISPLAY_CREDITS = course.CREDIT_LABEL_CODE === 'P' ?
																					this.$options.filters.fixed(course.CREDITS_IN_PROGRESS, 3) :
																					this.$options.filters.fixed(course.CREDITS_EARNED, 3);

							// Configure Course label
							course.FORMATTED_COURSE_LABEL = course.CREDIT_LABEL_CODE === 'P' ?
								`${course.COURSE_TITLE}*` : course.COURSE_TITLE;

							if(course.CREDIT_LABEL_CODE === 'P') {
								department.COURSES_IN_PROGRESS.push(course);
							} else {
								department.COURSES_NOT_IN_PROGRESS.push(course);
							}
						}
						departmentData.push(department);
					}
				}

				return departmentData;
			},
			dataExists() {
				return Object.keys(this.graduationProgressData).length > 0;
			},
			graduationProgressByYear() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.course' ),
						key: 'FORMATTED_COURSE_LABEL',
						customCol: 'course'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.grade' ),
						key: 'GRADE_LEVEL',
						customCol: 'grade'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.finalGrade' ),
						key: 'FINAL_GRADE_LETTER_AND_ALPHA',
						customCol: 'finalGrad'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.credits' ),
						key: 'DISPLAY_CREDITS',
						customCol: 'credits'
					}
				];
			},
			graduationProgressByDepartment() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.course' ),
						key: 'FORMATTED_COURSE_LABEL',
						customCol: 'course'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.year' ),
						key: 'SCHOOL_YEAR',
						customCol: 'year'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.grade' ),
						key: 'GRADE_LEVEL',
						customCol: 'grade'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.finalGrade' ),
						key: 'FINAL_GRADE_LETTER_AND_ALPHA',
						customCol: 'finalGrade'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.credits' ),
						key: 'DISPLAY_CREDITS',
						customCol: 'credits'
					}
				];
			},
			graduationRequirementItems() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.requirement' ),
						key: 'ITEM_DESC',
						customCol: 'item_desc'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.GraduationProgressReport.status' ),
						key: 'STATUS_DESC',
						customCol: 'status'
					}
				];
			}
		},
		components: {
			ProgressReportDepartments,
			ProgressReportYears,
			ProgressBar,
			PanelBasic,
			TableListRow,
			TableEditableList
		},
		methods: {
			getPercent(department) {
				let earned = !isNaN(department.CREDITS_EARNED) ? +department.CREDITS_EARNED : 0;
				let inProgress = !isNaN(department.CREDITS_IN_PROGRESS) ? +department.CREDITS_IN_PROGRESS : 0;
				let total = !isNaN(department.TOTAL_CREDITS) ? +department.TOTAL_CREDITS : 0;

				let obj = {
					IN_PROGRESS: Math.round((inProgress / total) * 100),
					COMPLETED: Math.round((earned / total) * 100),
					TOTAL_REQUIRED: total
				};

				if(obj.COMPLETED > 100) {
					obj.COMPLETED = 100;
				}

				if((obj.IN_PROGRESS + obj.COMPLETED) > 100) {
					obj.IN_PROGRESS = 100 - obj.COMPLETED;
				}

				return obj;
			},
			getGraduationProgressReport() {
				const self = this;

				const progress = new GraduationProgress({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = progress.get();

				promise.then(response => {
					self.$set(self, 'graduationProgressData', response.data.data);
				});
			},
			getNonCourseBasedRequirements(){
				const self = this;

				const progress = new GraduationProgress({
					route: "graduation-progress/graduation-requirements",
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = progress.get();

				promise.then(response => {
					self.$set(self, 'graduationRequirements', response.data.data);
				});
			}
		},
		created () {
			this.$store.commit('setTitleIcon', 'graduation-cap');
			this.$store.commit('setTitle', 'MAIN_CONTENT.GraduationProgressReport.sideMenuGraduationProgressLink');
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.GRAD_PROG_FLG === 'Y') {
				this.getGraduationProgressReport();
				this.getNonCourseBasedRequirements();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	}
</script>

<style scoped>
	.metRequirements {
		color: green;
	}
	.gray-header{
		background-color: #aaa !important;
		margin-top: 5px;
		padding: 2px 8px;
		font-size: 1.2em;
	}
	.instructions h1 {
		background-color: none !important;
		color: black !important;
	}
	.instructions {
		padding: 20px 30px !important;
		border-radius: 5px !important;
		background-color: #d6eef7 !important;
		color: #157291 !important;
		margin-top: 20px !important;
	}
</style>
